import {h, Component, render} from 'preact'
import {default as CategoryMenu} from './components/menu'
import CardList from './components/cardList'

class App extends Component {
  constructor({items, categories, ...props}) {
    super(props)
    this.state = {
      items: items,
      query: "",
      activeCategory: null
    }
  }

  onSelectCategory = (category) => {
    if (category == this.state.activeCategory) {
      category = null
    }
    this.setState({activeCategory: category})
    this.filterItems()
  }

  onInput = (e) => {
    const query = e.target.value
    this.setState({query})
    this.filterItems()
  }

  filterItems () {
    const {activeCategory, query} = this.state
    let items = this.props.items

    const filteredItems = items
      .filter((item) => this.filterByCategory(item, activeCategory))
      .filter((item) => this.filterByQuery(item, query))
    this.setState({items: filteredItems})
  }

  filterByCategory (item, category) {
    if (!category) return true
    return item.categories.indexOf(category) >= 0
  }

  filterByQuery (item, query) {
    if (query == "") return true
    const keywords = query.split(" ")
    for (let i=0; i<= keywords.length - 1; i++) {
      const keyword = keywords[i]
      const hasTitle = item.title && (item.title.indexOf(keyword) >= 0)
      const hasDescription = item.description && (item.description.indexOf(keyword) >= 0)

      if (!(hasTitle || hasDescription)) {
        return false
      }
    }
    return true
  }

  render({categories}, {activeCategory, items, query}) {
    return (
      <div class="category-filter">
        <div class="row align-items-center">
          <div class="col-md-8">
            <h2>Wissensbausteine</h2>
            <CategoryMenu
              onClick={this.onSelectCategory}
              activeCategory={activeCategory}
              categories={categories} />
          </div>
          <div class="col-md-4">
            <input onInput={this.onInput} value={query} class="form-control"
              placeholder="Wissen durchsuchen..." />
          </div>
        </div>
        <hr />
        <CardList cards={items} activeCategory={activeCategory} />
      </div>
    );
  }
}

export default class AppAdapter {
  constructor(element, items) {
    this.element = element
    this.items = items
    this.vElement = null

    this.render()
  }

  generateCategories () {
    return this.items
      .reduce((list, item) => {
        item.categories.forEach((category) => {
          if (!list.includes(category))
            list.push(category)
        })
        return list
      }, [])
  }

  render() {
    this.vElement = render(
      <App items={this.items} categories={this.generateCategories()} />,
      this.element
    )
  }
}
